var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fourQuadrants-box"},[_c('div',{staticClass:"historyChart",attrs:{"id":"historyChart" + _vm.id_type}})])
}
var staticRenderFns = []

export { render, staticRenderFns }